import {
    addHostAccount,
    HostSourceInformation,
    SourceAuthType,
    SourceType,
} from 'owa-account-source-list';
import { LoadState, setLoadState } from 'owa-account-source-list-store';
import { MailboxType } from 'owa-client-ids';
import { getDefaultUserEmailAddress, getUserConfiguration, isConsumer } from 'owa-session-store';

/**
 * Monarch multiple accounts introduces support for the owa-account-source-list-store, when not
 * in Monarch we initialize the store with the information in the default user configuration.
 */
export function initOwaAccountSourceListStore() {
    const settings = getUserConfiguration().SessionSettings;
    const email = getDefaultUserEmailAddress();
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2532 (21,25): Object is possibly 'undefined'.
    // @ts-expect-error
    const displayName = settings.UserPrincipalName || settings.UserEmailAddress || email;
    const account: HostSourceInformation = {
        sourceType: SourceType.Mailbox,
        authProviderType: isConsumer() ? SourceAuthType.OutlookDotCom : SourceAuthType.Microsoft365,
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2322 (28,9): Type 'string | undefined' is not assignable to type 'string'.
        // @ts-expect-error
        displayName: displayName,
        characteristics: {
            supportsCalendar: true,
            supportsContacts: true,
            supportsMail: true,
            supportsSettings: true,
        },
        mailbox: {
            type: 'UserMailbox' as MailboxType,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (40,13): Type 'string | undefined' is not assignable to type 'string'.
            // @ts-expect-error
            name: displayName,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (44,13): Type 'string | undefined' is not assignable to type 'string'.
            // @ts-expect-error
            displayName: displayName,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (48,13): Type 'string | undefined' is not assignable to type 'string'.
            // @ts-expect-error
            emailAddress: settings.UserEmailAddress || email,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (52,13): Type 'string | undefined' is not assignable to type 'string'.
            // @ts-expect-error
            loginAddress: settings.LogonEmailAddress || email,
            // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
            // -> Error TS2322 (56,13): Type 'string | undefined' is not assignable to type 'string'.
            // @ts-expect-error
            userIdentity: settings.LogonEmailAddress || email,
            routingHint: '',
            alternateId: '',
            accountUniqueId: '',
            imageUrl: '',
            profileUrl: '',
        },
    };

    addHostAccount(account);
    setLoadState(LoadState.Loaded);
}
